import React from 'react'
import styled from 'styled-components'
import {GIFT_SHOP_PROFILE_CHANGE_USERNAME_LIMIT} from 'consts'
import {useTranslation} from 'i18n'
import {Button, Modal, Paragraph} from 'common/components'
import convertUnit from 'lib/unit'
import {useSelector} from 'lib/redux'

const StyledModal = styled(Modal)`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: ${convertUnit(300)};
  padding: ${convertUnit(20)};
  border-radius: ${convertUnit(16)};
`
const StyledTitle = styled(Paragraph)`
  text-align: center;
  word-break: break-word;
`
const StyledParagraph = styled(StyledTitle)`
  margin-top: ${convertUnit(12)};
  line-height: ${convertUnit(26)};
`
const StyledButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  gap: ${convertUnit(20)};
  margin-top: ${convertUnit(20)};
`
const StyledButtonModal = styled(Button)`
  width: 100%;
`

interface GiftShopEditProfileModalNameChangeProps {
  visible: boolean
  title: string
  nameType: string
  onToggle(): void
  isSecondTime: boolean
  onSave(): void
}
export default function GiftShopEditProfileModalNameChange({
  visible,
  title,
  nameType,
  onToggle,
  isSecondTime,
  onSave,
}: GiftShopEditProfileModalNameChangeProps) {
  const {translate} = useTranslation()
  const {lang} = useSelector('user') || {}
  return (
    <StyledModal visible={visible} onBackdropPress={onToggle}>
      <StyledTitle fontSize="xl" fontWeight="bold">
        {title}
      </StyledTitle>
      <StyledParagraph fontSize="l">
        {translate('giftShop:changeNameWarningModal1', {
          name: nameType.toLowerCase(),
        })}
      </StyledParagraph>
      <StyledParagraph
        fontSize="l"
        color={isSecondTime ? 'danger_5' : 'gray_5'}>
        {translate(
          isSecondTime
            ? 'giftShop:changeNameWarningModal3'
            : 'giftShop:changeNameWarningModal2',
          {
            name:
              lang === 'en' || isSecondTime ? nameType.toLowerCase() : nameType,
            limit: GIFT_SHOP_PROFILE_CHANGE_USERNAME_LIMIT,
          },
        )}
      </StyledParagraph>
      <StyledButtonContainer>
        <StyledButtonModal
          label={translate('global:cancel')}
          backgroundHoverColor="white_3"
          backgroundColor="white_2"
          color="primary_5"
          onClick={onToggle}
        />
        <StyledButtonModal
          backgroundColor="primary_5"
          label={translate('global:save')}
          onClick={onSave}
        />
      </StyledButtonContainer>
    </StyledModal>
  )
}
